var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTkTokelau(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#00247D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8656 33.2442C50.4938 33.2348 43.9781 29.7754 38.5312 25.3317C31.3875 19.5098 16.0031 10.2004 11.475 8.68169C11.0063 8.52231 12.4406 9.48794 12.6281 9.79731C17.4563 15.5161 13.6031 26.2973 7.56563 31.7254C5.74688 33.1129 5.84063 33.1879 2.475 33.3192V33.6379L49.8656 33.2442ZM50.2594 33.8723C50.2594 33.8723 50.7188 34.2004 50.7188 34.4442C50.7188 34.7161 50.2031 35.0723 50.2031 35.0723L3.46875 35.5879L2.60625 35.0161L3.80625 34.2754L50.2594 33.8723Z",
    fill: "#FED100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.9875 10.2277L50.3625 11.3715L49.3875 10.6684L48.4219 11.3715L48.7875 10.2277L47.8219 9.52461H49.0219L49.3875 8.38086L49.7625 9.52461H50.9625L49.9875 10.2277ZM42.6656 15.609L41.8594 15.0184H42.8625L43.1719 14.0715L43.4813 15.0184H44.475L43.6688 15.609L43.9781 16.5559L43.1719 15.9652L42.3563 16.5559L42.6656 15.609ZM56.2781 16.8277L56.6531 15.684L57.0188 16.8277H58.2188L57.2531 17.5309L57.6188 18.6746L56.6531 17.9715L55.6781 18.6746L56.0531 17.5309L55.0781 16.8277H56.2781ZM48.9562 28.2934L49.3875 26.9621L49.8188 28.2934H51.225L50.0906 29.109L50.5219 30.4496L49.3875 29.6246L48.2531 30.4496L48.6938 29.109L47.5594 28.2934H48.9562Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTkTokelau);
export default __webpack_public_path__ + "static/media/tk Tokelau.48e5171f33d357720b0e951cd12f66eb.svg";
export { ForwardRef as ReactComponent };